module.exports = __webpack_public_path__ + "img/170120.0646336d.png";